import CommonIFrame from '../atoms/CommonIFrame';

const TradeOverview = () => {
    return (
        <CommonIFrame
            src="https://id-preview--cb449b1d-f4d7-498d-8333-5567e3b9f98c.lovable.app/"
            title="Trade Overview"
        />
    );
};

export default TradeOverview;
